import React, { ReactElement } from 'react';
import moment from "moment";
import LinesEllipsis from 'react-lines-ellipsis/lib/loose';
import { ISrcSet, Picture } from '@kursk/components/ui/Picture/Picture';
import { EntityCardFavoritesButton } from '@kursk/components/ui/FavoritesButton/EntityCardFavoritesButton';
import { EntityType } from "@common/redux/types/common";
import { getPriceTitle } from '@kursk/utils/getPriceTitle';
import { getAddress } from "@kursk/utils/getAddress";
import { getWorkingHours } from "@kursk/utils/getWorkingHours";
import { IMapPointEntity } from "@common/redux/types/map";
import styles from './MapEntityCard.module.scss';


interface IEntityCardProps {
  entity: IMapPointEntity;
  entityType: EntityType;
}

export function MapEntityCard({ entity, entityType }: IEntityCardProps): ReactElement {

  const ticketsPriceTitle = entity.isFree ? 'Бесплатно' :
    getPriceTitle(entity.ticketsInfo?.minPrice, entity.ticketsInfo?.maxPrice)

  const imgSrcSet: ISrcSet[] = [
    {
      media: '(min-width: 0px)',
      width: 295,
      height: 164,
    }
  ];

  const prepareDate = (): string => {
    const format = 'DD MMMM YYYY';
    const start = moment(entity?.periodStart);
    const end = moment(entity?.periodEnd);

    const isSeance = start.month() === end.month() && start.date() === end.date() && start.year() === end.year();

    if (isSeance) {
      return start.format(format);
    } else {
      const now = moment();
      const currentStart = start.valueOf() < now.valueOf() ? now : start;
      return `${currentStart.format(format)} - ${end.format(format)}`;
    }
  };

  const returnUrlPart = (entityType) => {
    if (entityType === "schedules" || entityType === "seances") return "events"

    return entityType
  }

  const returnUrlEntityId = (entityType) => {
    if (entityType === "schedules" || entityType === "seances") return entity.eventId
    return entity._id
  }

  return (
    <div
      className={styles.wrapper}
    >
      <div className={styles.pictureWrapper}>
        <Picture className={styles.image} srcSet={imgSrcSet} image={entity.image}/>
        <div className={styles.favoritesButtonWrapper}>
          <EntityCardFavoritesButton entityId={`${entity._id}`} entityType={entity.entityType} />
        </div>
      </div>
      <div className={styles.info}>
        {(entity.periodEnd || entity.periodStart) && (
          <div className={styles.schedule}>{prepareDate()}</div>
        )}
        {entity.schedule && (
          <div className={styles.schedule}>{getWorkingHours(entity.schedule)}</div>
        )}
        <a
          href={`/${returnUrlPart(entityType)}/${returnUrlEntityId(entityType)}/${entity.sysName}`}
          rel="noreferrer"
          target="_blank"
        >
          <LinesEllipsis
            text={entity.name}
            maxLine={3}
            ellipsis='...'
            trimRight
            basedOn='letters'
            className={styles.title}
          />
        </a>

        <div className={styles.addressTitle}>Адрес:</div>
        <div className={styles.address}>
          <LinesEllipsis
            text={getAddress(entity.address)}
            maxLine={2}
            ellipsis='...'
            trimRight
            basedOn='letters'
          />
        </div>
        {(entity.ticketsInfo?.available > 0 || entity.ticketsInfo?.unlimited) && ticketsPriceTitle && (
          <div className={styles.price}>
            {ticketsPriceTitle}
          </div>
        )}
      </div>
    </div>
  )
}
